import React from 'react';
import { useTranslation } from 'react-i18next';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
// Create rtl cache

const defaultenFontFamily = 'Lato !important';
const defaultarFontFamily = "'El Messiri', sans-serif !important";
const cacheRtl = createCache({
  key: 'muirtl',
  fontFamily: defaultarFontFamily,
  stylisPlugins: [prefixer, rtlPlugin],
});
const cacheLtr = createCache({
  key: 'muiltr',
  fontFamily: defaultenFontFamily,
  stylisPlugins: [prefixer],
});

const themeltr = createTheme({
  direction: 'ltr',
  fontFamily: defaultenFontFamily,
  typography: {
    fontFamily: defaultenFontFamily,
    allVariants: { defaultenFontFamily },
    root: {
      fontFamily: defaultenFontFamily,
    },
    button: {
      fontFamily: defaultenFontFamily,
    },
    body2: {
      fontFamily: defaultenFontFamily,
    },
    body1: {
      fontFamily: defaultenFontFamily,
    },
    caption: {
      fontFamily: defaultenFontFamily,
    },
    h1: {
      fontFamily: defaultenFontFamily,
    },
    h2: {
      fontFamily: defaultenFontFamily,
    },
    h3: {
      fontFamily: defaultenFontFamily,
    },
    h4: {
      fontFamily: defaultenFontFamily,
    },
    h5: {
      fontFamily: defaultenFontFamily,
    },
    h6: {
      fontFamily: defaultenFontFamily,
    },
    subtitle1: {
      fontFamily: defaultenFontFamily,
    },
    subtitle2: {
      fontFamily: defaultenFontFamily,
    },
  },
  body1: {
    fontFamily: defaultenFontFamily,
  },
  root: {
    fontFamily: defaultenFontFamily,
  },
  body2: {
    fontFamily: defaultenFontFamily,
  },

  caption: {
    fontFamily: defaultenFontFamily,
  },
  button: {
    fontFamily: defaultenFontFamily,
  },
  h1: {
    fontFamily: defaultenFontFamily,
  },
  h2: {
    fontFamily: defaultenFontFamily,
  },
  h3: {
    fontFamily: defaultenFontFamily,
  },
  h4: {
    fontFamily: defaultenFontFamily,
  },
  h5: {
    fontFamily: defaultenFontFamily,
  },
  h6: {
    fontFamily: defaultenFontFamily,
  },
  subtitle1: {
    fontFamily: defaultenFontFamily,
  },
  subtitle2: {
    fontFamily: defaultenFontFamily,
  },
  overline: {
    fontFamily: defaultenFontFamily,
  },
  inherit: {
    fontFamily: defaultenFontFamily,
  },
  alignLeft: {
    fontFamily: defaultenFontFamily,
  },
  alignCenter: {
    fontFamily: defaultenFontFamily,
  },
  alignRight: {
    fontFamily: defaultenFontFamily,
  },
  alignJustify: {
    fontFamily: defaultenFontFamily,
  },
  noWrap: {
    fontFamily: defaultenFontFamily,
  },
  gutterBottom: {
    fontFamily: defaultenFontFamily,
  },
  paragraph: {
    fontFamily: defaultenFontFamily,
  },
});
const themertl = createTheme({
  direction: 'rtl',
  fontFamily: defaultarFontFamily,
  typography: {
    fontFamily: defaultarFontFamily,
    allVariants: { defaultarFontFamily },
    root: {
      fontFamily: defaultarFontFamily,
    },
    button: {
      fontFamily: defaultarFontFamily,
    },
    body2: {
      fontFamily: defaultarFontFamily,
    },
    body1: {
      fontFamily: defaultarFontFamily,
    },
    caption: {
      fontFamily: defaultarFontFamily,
    },
    h1: {
      fontFamily: defaultarFontFamily,
    },
    h2: {
      fontFamily: defaultarFontFamily,
    },
    h3: {
      fontFamily: defaultarFontFamily,
    },
    h4: {
      fontFamily: defaultarFontFamily,
    },
    h5: {
      fontFamily: defaultarFontFamily,
    },
    h6: {
      fontFamily: defaultarFontFamily,
    },
    subtitle1: {
      fontFamily: defaultarFontFamily,
    },
    subtitle2: {
      fontFamily: defaultarFontFamily,
    },
  },
  body1: {
    fontFamily: defaultarFontFamily,
  },
  root: {
    fontFamily: defaultarFontFamily,
  },
  body2: {
    fontFamily: defaultarFontFamily,
  },

  caption: {
    fontFamily: defaultarFontFamily,
  },
  button: {
    fontFamily: defaultarFontFamily,
  },
  h1: {
    fontFamily: defaultarFontFamily,
  },
  h2: {
    fontFamily: defaultarFontFamily,
  },
  h3: {
    fontFamily: defaultarFontFamily,
  },
  h4: {
    fontFamily: defaultarFontFamily,
  },
  h5: {
    fontFamily: defaultarFontFamily,
  },
  h6: {
    fontFamily: defaultarFontFamily,
  },
  subtitle1: {
    fontFamily: defaultarFontFamily,
  },
  subtitle2: {
    fontFamily: defaultarFontFamily,
  },
  overline: {
    fontFamily: defaultarFontFamily,
  },
  inherit: {
    fontFamily: defaultarFontFamily,
  },
  alignLeft: {
    fontFamily: defaultarFontFamily,
  },
  alignCenter: {
    fontFamily: defaultarFontFamily,
  },
  alignRight: {
    fontFamily: defaultarFontFamily,
  },
  alignJustify: {
    fontFamily: defaultarFontFamily,
  },
  noWrap: {
    fontFamily: defaultarFontFamily,
  },
  gutterBottom: {
    fontFamily: defaultarFontFamily,
  },
  paragraph: {
    fontFamily: defaultarFontFamily,
  },
  input: {
    fontFamily: defaultarFontFamily,
  },
  select: {
    fontFamily: defaultarFontFamily,
  },
});
const Compdirection = (prop) => {
  const { i18n } = useTranslation();


  return (
    <CacheProvider value={i18n.language == 'ar' ? cacheRtl : cacheLtr}>
      <ThemeProvider theme={i18n.language == 'ar' ? themertl : themeltr}>
        {prop.children}
      </ThemeProvider>
    </CacheProvider>
  );
};
export default Compdirection;
